import React from 'react';
import { useSelector } from 'react-redux';
import types from './types';
import percentToHex from '../PercentToHex';
import UIEditorSubcomponent from '../UIEditorSubcomponent';
import Scenario from '../../../classes/scenarioElements/Scenario';
import Spacer from '../../layout/Spacer';
import { QuizType } from '../../../globals';
import QuizManager from '../../../classes/QuizManager';

export default function UIContinueButton(props)
{
	let properties = {
		'button text': {
			type: 'text',
			default: 'Continue'
		},
		'button text color': {
			type: 'color',
			default: '#ffffff'
		},
		'button text alpha': {
			type: 'range',
			default: 80
		},
		'button background color': {
			type: 'color',
			default: '#DFA330'
		},
		'button background alpha': {
			type: 'range',
			default: 100
		},
		'visible': {
			type: 'toggle',
			default: true
		}
	}

	if(props.disabledProperties)
	{
		for(const propertyName of props.disabledProperties)
		{
			delete properties[propertyName];
		}

	}

	if (props.getProperties)
	{
		return properties;
	}

	if (props.context === 'editor')
	{
		return (
			<UIEditorSubcomponent
				title={'Continue Button'}
				subcomponent={types.CONTINUE_BUTTON}
				properties={properties}
				{...props}
			/>
		)
	}
	else if (props.data.visible)
	{
		const quizSettings = useSelector(store => store.checklistModule.quizSettings);

		const simulation = props.context === 'simulation';
		const data = props.data;
		const okText = data['button text'].value;
		const okColor = data['button text color'].value + percentToHex(data['button text alpha'].value);
		const okBgColor = data['button background color'].value + percentToHex(data['button background alpha'].value);

		if (data['visible'].value !== true) return null;

		return (
			<div className={["uiButtonsRow", props.template].join(' ')}
				data-name={'ui-buttons-continue-row-root'}
				data-central={"true"}
			>
				{
					!(quizSettings.type === QuizType.GRADED && quizSettings.practiceSessions) ||
					!QuizManager.shouldAllowRetry()
					 ? null :
						<Spacer size={{ x: "50%" }} />
				}
				<div className={["uiButton", props.template].join(' ')}
					data-name={"ui-button-confirm"}
					style={{
						border: "none",
						backgroundColor: okBgColor,
						fontSize: simulation ? 36 : (30 * props.scale) + "px",
						color: okColor,
						width: (quizSettings.type === QuizType.GRADED && quizSettings.practiceSessions) ? "40%" : '33%',
					}}
					onClick={(e) =>
					{
						const nextStep = Scenario.currentStep().getNextStep();
						if (nextStep)
						{
							Scenario.setCurrentStep(nextStep);
						}
					}}
				>
					{okText}
				</div>
			</div>
		);
	}

	return null;
}